import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/layout.css";
import "../css/login.css";
import findGif from "../css/loading_old.gif";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from "../../apiService/allApi";

export default function Login() {
  const history = useHistory();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);

      const respone = await apiRequest("login", "POST", { Phone, referral });
      // .then((respone) => {
      setIsloading1(false);
      if (respone?.data?.status == 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: respone?.data?.msg,
        });
      } else if (respone?.data?.status == 200) {
        setOtp(true);
        setSecretCode(respone?.data?.secret);
        if (respone?.data?.myToken) {
          Swal.fire({
            icon: "success",
            title: "OTP",
            text: "Demo Account Testing OTP: " + respone?.data?.myToken,
          });
        }
      }
      // })
      // .catch((e) => {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Something went wrong",
      //   });
      // });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", {
        Phone,
        twofactor_code,
        referral,
        secretCode,
      });

      setIsloading1(false);

      if (response?.data?.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.msg,
        });
      } else if (response?.data?.status === 200) {
        const token = response?.data?.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  // otp valid
  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true); // Show the Resend button when OTP expires
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false); // Hide the Resend button after clicking it
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" }}>
        <div className="unique-login-container">
          {/* Side Decorative Element */}
          <div className="side-accent"></div>

          <div className="main-auth-card">
            <div className="auth-inner">
              <header className="auth-intro">
                <div className="logo-sq">***</div>
                <h2>
                  Join the <span>3Star</span>
                </h2>
                <p>Your journey starts with a simple tap.</p>
              </header>

              <div className="auth-fields-group">
                {/* Phone Input */}
                <div className="neo-input-box">
                  <input
                    name="mobile"
                    type="tel"
                    required
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <label>Mobile (+91)</label>
                  <div className="focus-border"></div>
                </div>

                {/* OTP Input with Logic */}
                {otp && (
                  <div className="otp-wrapper-animate">
                    <div className="neo-input-box">
                      <input
                        name="password"
                        type="tel"
                        required
                        onChange={(e) => settwofactor_code(e.target.value)}
                      />
                      <label>Enter OTP</label>
                      <div className="focus-border-otp"></div>
                    </div>

                    <div className="otp-footer">
                      {isValid || seconds !== 0 ? (
                        <span className="timer-count">
                          Resend in <b>{seconds}s</b>
                        </span>
                      ) : (
                        showResend && (
                          <button
                            className="text-action-btn"
                            onClick={handleResendClick}
                          >
                            Get New Code
                          </button>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Button Logic Container */}
              <div className="auth-actions">
                {!otp ? (
                  <button
                    className={`glow-btn ${isLoading1 ? "active-loading" : ""}`}
                    onClick={(e) => {
                      handleClick(e);
                      setIsValid(true);
                    }}
                    disabled={isLoading1}
                  >
                    {isLoading1 ? (
                      <span className="loader-dots"></span>
                    ) : (
                      "Send Otp"
                    )}
                  </button>
                ) : (
                  <button
                    className={`glow-btn verify-mode ${
                      isLoading1 ? "active-loading" : ""
                    }`}
                    onClick={(e) => varifyOtp(e)}
                    disabled={isLoading1}
                  >
                    {isLoading1 ? (
                      <span className="loader-dots"></span>
                    ) : (
                      "Verify & Access"
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
